// extracted by mini-css-extract-plugin
export var bounce = "_ok-1";
export var generatingText = "_ok-6";
export var lightning = "_ok-4";
export var popup = "_ok-5";
export var progressBar = "_ok-7";
export var progressFill = "_ok-8";
export var progressShimmer = "_ok-9";
export var progressText = "_ok-a";
export var shimmer = "_ok-3";
export var uploadIcon = "_ok-0";
export var uploadingText = "_ok-2";